<!-- EL QR ET PORTA A LA VISUALITZACIÓ DELS DOCUMENTS DIGITALS DEL UUIDQR INDICAT D'UNA RUTA -->
<div *ngIf="uuidQR">
    <div *ngIf="formatDocumentQRCode" class="codeqr" (click)="onClickQR()">
        <div class="img"><img [src]="formatDocumentQRCode" /></div>
        <div class="help-qr">{{ helpResource | translate }}</div>
    </div>
</div>